import { render, staticRenderFns } from "./ReviewOrderList.vue?vue&type=template&id=59e10806"
import script from "./ReviewOrderList.vue?vue&type=script&lang=js"
export * from "./ReviewOrderList.vue?vue&type=script&lang=js"
import style0 from "./ReviewOrderList.vue?vue&type=style&index=0&id=59e10806&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports